export default {
    list: {
        title: 'Actividad',
        subtitle: 'Ver actividad reciente',
        loading: 'Cargando actividad...',
    },
    sender: {
        title: 'Actividad',
        subtitle: 'Actualizaciones y notificaciones para tu cuenta Remitente',
    },
    shipper: {
        title: 'Actividad',
        subtitle: 'Actualizaciones y notificaciones para tu cuenta Expedidor',
    },
    receiver: {
        title: 'Actividad',
        subtitle: 'Actualizaciones y notificaciones para tu cuenta Destinatario',
    },
    freightForwarder: {
        title: 'Actividad',
        subtitle: 'Actualizaciones operativas para tu cuenta Freight Forwarder',
    },
};

